export default __webpack_public_path__ + "1be157a899ea589d1d4687c9d38ac823.png";